export default __webpack_public_path__ + "static/media/welcomeBg_responsive.a33cda23.jpg";